window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.AUDIO_NOTE = function() {
	this.initialize(img.SplashAssets_AUDIO_NOTE);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,402,115);


(lib.headphone = function() {
	this.initialize(img.SplashAssets_headphone);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,49,48);


(lib.loading = function() {
	this.initialize(img.SplashAssets_loading);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1020,64);


(lib.SplashScreen_BG_v02 = function() {
	this.initialize(img.SplashAssets_SplashScreen_BG_v02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.START_down2 = function() {
	this.initialize(img.SplashAssets_START_down2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,220,115);


(lib.START_over2 = function() {
	this.initialize(img.SplashAssets_START_over2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,220,115);


(lib.START_up2 = function() {
	this.initialize(img.SplashAssets_START_up2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,220,115);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.HeadphoneIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.headphone();
	this.instance.setTransform(-24.5,-24.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HeadphoneIcon, new cjs.Rectangle(-24.5,-24.5,49,48), null);


(lib.bg_ImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SplashScreen_BG_v02();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.bg_ImageContainer, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.back_disabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.START_up2();
	this.instance.setTransform(-111,-58);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.back_disabled, new cjs.Rectangle(-111,-58,220,115), null);


(lib.LoadingBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// LoadingBarBar (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AhOBzIAAjlICdAAIAADlg");
	var mask_graphics_1 = new cjs.Graphics().p("AhkBzIAAjlIDJAAIAADlg");
	var mask_graphics_2 = new cjs.Graphics().p("Ah7BzIAAjlID3AAIAADlg");
	var mask_graphics_3 = new cjs.Graphics().p("AiSBzIAAjlIElAAIAADlg");
	var mask_graphics_4 = new cjs.Graphics().p("AipBzIAAjlIFTAAIAADlg");
	var mask_graphics_5 = new cjs.Graphics().p("AjABzIAAjlIGBAAIAADlg");
	var mask_graphics_6 = new cjs.Graphics().p("AjWBzIAAjlIGtAAIAADlg");
	var mask_graphics_7 = new cjs.Graphics().p("AjtBzIAAjlIHbAAIAADlg");
	var mask_graphics_8 = new cjs.Graphics().p("AkEBzIAAjlIIJAAIAADlg");
	var mask_graphics_9 = new cjs.Graphics().p("AkbBzIAAjlII3AAIAADlg");
	var mask_graphics_10 = new cjs.Graphics().p("AkxBzIAAjlIJjAAIAADlg");
	var mask_graphics_11 = new cjs.Graphics().p("AlIBzIAAjlIKRAAIAADlg");
	var mask_graphics_12 = new cjs.Graphics().p("AlfBzIAAjlIK/AAIAADlg");
	var mask_graphics_13 = new cjs.Graphics().p("Al2BzIAAjlILtAAIAADlg");
	var mask_graphics_14 = new cjs.Graphics().p("AmNBzIAAjlIMbAAIAADlg");
	var mask_graphics_15 = new cjs.Graphics().p("AmjBzIAAjlINHAAIAADlg");
	var mask_graphics_16 = new cjs.Graphics().p("Am6BzIAAjlIN1AAIAADlg");
	var mask_graphics_17 = new cjs.Graphics().p("AnRBzIAAjlIOjAAIAADlg");
	var mask_graphics_18 = new cjs.Graphics().p("AnoBzIAAjlIPRAAIAADlg");
	var mask_graphics_19 = new cjs.Graphics().p("An+BzIAAjlIP9AAIAADlg");
	var mask_graphics_20 = new cjs.Graphics().p("AoVBzIAAjlIQrAAIAADlg");
	var mask_graphics_21 = new cjs.Graphics().p("AosBzIAAjlIRZAAIAADlg");
	var mask_graphics_22 = new cjs.Graphics().p("ApDBzIAAjlISHAAIAADlg");
	var mask_graphics_23 = new cjs.Graphics().p("ApaBzIAAjlIS1AAIAADlg");
	var mask_graphics_24 = new cjs.Graphics().p("ApwBzIAAjlIThAAIAADlg");
	var mask_graphics_25 = new cjs.Graphics().p("AqHBzIAAjlIUPAAIAADlg");
	var mask_graphics_26 = new cjs.Graphics().p("AqeBzIAAjlIU9AAIAADlg");
	var mask_graphics_27 = new cjs.Graphics().p("Aq1BzIAAjlIVrAAIAADlg");
	var mask_graphics_28 = new cjs.Graphics().p("ArMBzIAAjlIWZAAIAADlg");
	var mask_graphics_29 = new cjs.Graphics().p("AriBzIAAjlIXFAAIAADlg");
	var mask_graphics_30 = new cjs.Graphics().p("Ar5BzIAAjlIXzAAIAADlg");
	var mask_graphics_31 = new cjs.Graphics().p("AsQBzIAAjlIYhAAIAADlg");
	var mask_graphics_32 = new cjs.Graphics().p("AsnBzIAAjlIZPAAIAADlg");
	var mask_graphics_33 = new cjs.Graphics().p("As9BzIAAjlIZ7AAIAADlg");
	var mask_graphics_34 = new cjs.Graphics().p("AtUBzIAAjlIapAAIAADlg");
	var mask_graphics_35 = new cjs.Graphics().p("AtrBzIAAjlIbXAAIAADlg");
	var mask_graphics_36 = new cjs.Graphics().p("AuCBzIAAjlIcFAAIAADlg");
	var mask_graphics_37 = new cjs.Graphics().p("AuZBzIAAjlIczAAIAADlg");
	var mask_graphics_38 = new cjs.Graphics().p("AuvBzIAAjlIdfAAIAADlg");
	var mask_graphics_39 = new cjs.Graphics().p("AvGBzIAAjlIeNAAIAADlg");
	var mask_graphics_40 = new cjs.Graphics().p("AvdBzIAAjlIe7AAIAADlg");
	var mask_graphics_41 = new cjs.Graphics().p("Av0BzIAAjlIfpAAIAADlg");
	var mask_graphics_42 = new cjs.Graphics().p("AwKBzIAAjlMAgVAAAIAADlg");
	var mask_graphics_43 = new cjs.Graphics().p("AwhBzIAAjlMAhDAAAIAADlg");
	var mask_graphics_44 = new cjs.Graphics().p("Aw4BzIAAjlMAhxAAAIAADlg");
	var mask_graphics_45 = new cjs.Graphics().p("AxPBzIAAjlMAifAAAIAADlg");
	var mask_graphics_46 = new cjs.Graphics().p("AxmBzIAAjlMAjNAAAIAADlg");
	var mask_graphics_47 = new cjs.Graphics().p("Ax8BzIAAjlMAj5AAAIAADlg");
	var mask_graphics_48 = new cjs.Graphics().p("AyTBzIAAjlMAknAAAIAADlg");
	var mask_graphics_49 = new cjs.Graphics().p("AyqBzIAAjlMAlVAAAIAADlg");
	var mask_graphics_50 = new cjs.Graphics().p("AzBBzIAAjlMAmDAAAIAADlg");
	var mask_graphics_51 = new cjs.Graphics().p("AzXBzIAAjlMAmvAAAIAADlg");
	var mask_graphics_52 = new cjs.Graphics().p("AzuBzIAAjlMAndAAAIAADlg");
	var mask_graphics_53 = new cjs.Graphics().p("A0FBzIAAjlMAoLAAAIAADlg");
	var mask_graphics_54 = new cjs.Graphics().p("A0cBzIAAjlMAo5AAAIAADlg");
	var mask_graphics_55 = new cjs.Graphics().p("A0zBzIAAjlMApnAAAIAADlg");
	var mask_graphics_56 = new cjs.Graphics().p("A1JBzIAAjlMAqTAAAIAADlg");
	var mask_graphics_57 = new cjs.Graphics().p("A1gBzIAAjlMArBAAAIAADlg");
	var mask_graphics_58 = new cjs.Graphics().p("A13BzIAAjlMArvAAAIAADlg");
	var mask_graphics_59 = new cjs.Graphics().p("A2OBzIAAjlMAsdAAAIAADlg");
	var mask_graphics_60 = new cjs.Graphics().p("A2lBzIAAjlMAtLAAAIAADlg");
	var mask_graphics_61 = new cjs.Graphics().p("A27BzIAAjlMAt3AAAIAADlg");
	var mask_graphics_62 = new cjs.Graphics().p("A3SBzIAAjlMAulAAAIAADlg");
	var mask_graphics_63 = new cjs.Graphics().p("A3pBzIAAjlMAvTAAAIAADlg");
	var mask_graphics_64 = new cjs.Graphics().p("A4ABzIAAjlMAwBAAAIAADlg");
	var mask_graphics_65 = new cjs.Graphics().p("A4WBzIAAjlMAwtAAAIAADlg");
	var mask_graphics_66 = new cjs.Graphics().p("A4tBzIAAjlMAxbAAAIAADlg");
	var mask_graphics_67 = new cjs.Graphics().p("A5EBzIAAjlMAyJAAAIAADlg");
	var mask_graphics_68 = new cjs.Graphics().p("A5bBzIAAjlMAy3AAAIAADlg");
	var mask_graphics_69 = new cjs.Graphics().p("A5yBzIAAjlMAzlAAAIAADlg");
	var mask_graphics_70 = new cjs.Graphics().p("A6IBzIAAjlMA0RAAAIAADlg");
	var mask_graphics_71 = new cjs.Graphics().p("A6fBzIAAjlMA0/AAAIAADlg");
	var mask_graphics_72 = new cjs.Graphics().p("A62BzIAAjlMA1tAAAIAADlg");
	var mask_graphics_73 = new cjs.Graphics().p("A7NBzIAAjlMA2bAAAIAADlg");
	var mask_graphics_74 = new cjs.Graphics().p("A7jBzIAAjlMA3HAAAIAADlg");
	var mask_graphics_75 = new cjs.Graphics().p("A76BzIAAjlMA31AAAIAADlg");
	var mask_graphics_76 = new cjs.Graphics().p("A8RBzIAAjlMA4jAAAIAADlg");
	var mask_graphics_77 = new cjs.Graphics().p("A8oBzIAAjlMA5RAAAIAADlg");
	var mask_graphics_78 = new cjs.Graphics().p("A8/BzIAAjlMA5/AAAIAADlg");
	var mask_graphics_79 = new cjs.Graphics().p("A9VBzIAAjlMA6rAAAIAADlg");
	var mask_graphics_80 = new cjs.Graphics().p("A9sBzIAAjlMA7ZAAAIAADlg");
	var mask_graphics_81 = new cjs.Graphics().p("A+DBzIAAjlMA8HAAAIAADlg");
	var mask_graphics_82 = new cjs.Graphics().p("A+aBzIAAjlMA81AAAIAADlg");
	var mask_graphics_83 = new cjs.Graphics().p("A+wBzIAAjlMA9hAAAIAADlg");
	var mask_graphics_84 = new cjs.Graphics().p("A/HBzIAAjlMA+PAAAIAADlg");
	var mask_graphics_85 = new cjs.Graphics().p("A/eBzIAAjlMA+9AAAIAADlg");
	var mask_graphics_86 = new cjs.Graphics().p("A/1BzIAAjlMA/rAAAIAADlg");
	var mask_graphics_87 = new cjs.Graphics().p("EggMABzIAAjlMBAZAAAIAADlg");
	var mask_graphics_88 = new cjs.Graphics().p("EggiABzIAAjlMBBFAAAIAADlg");
	var mask_graphics_89 = new cjs.Graphics().p("Egg5ABzIAAjlMBBzAAAIAADlg");
	var mask_graphics_90 = new cjs.Graphics().p("EghQABzIAAjlMBChAAAIAADlg");
	var mask_graphics_91 = new cjs.Graphics().p("EghnABzIAAjlMBDPAAAIAADlg");
	var mask_graphics_92 = new cjs.Graphics().p("Egh+ABzIAAjlMBD9AAAIAADlg");
	var mask_graphics_93 = new cjs.Graphics().p("EgiUABzIAAjlMBEpAAAIAADlg");
	var mask_graphics_94 = new cjs.Graphics().p("EgirABzIAAjlMBFXAAAIAADlg");
	var mask_graphics_95 = new cjs.Graphics().p("EgjCABzIAAjlMBGFAAAIAADlg");
	var mask_graphics_96 = new cjs.Graphics().p("EgjZABzIAAjlMBGzAAAIAADlg");
	var mask_graphics_97 = new cjs.Graphics().p("EgjvABzIAAjlMBHfAAAIAADlg");
	var mask_graphics_98 = new cjs.Graphics().p("EgkGABzIAAjlMBINAAAIAADlg");
	var mask_graphics_99 = new cjs.Graphics().p("EgkdABzIAAjlMBI7AAAIAADlg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:-4.5843,y:10.4969}).wait(1).to({graphics:mask_graphics_1,x:-2.262,y:10.4993}).wait(1).to({graphics:mask_graphics_2,x:0.0603,y:10.5017}).wait(1).to({graphics:mask_graphics_3,x:2.3825,y:10.5041}).wait(1).to({graphics:mask_graphics_4,x:4.7048,y:10.5065}).wait(1).to({graphics:mask_graphics_5,x:7.0271,y:10.5089}).wait(1).to({graphics:mask_graphics_6,x:9.3494,y:10.5114}).wait(1).to({graphics:mask_graphics_7,x:11.6716,y:10.5138}).wait(1).to({graphics:mask_graphics_8,x:13.9939,y:10.5162}).wait(1).to({graphics:mask_graphics_9,x:16.3162,y:10.5186}).wait(1).to({graphics:mask_graphics_10,x:18.6385,y:10.521}).wait(1).to({graphics:mask_graphics_11,x:20.9607,y:10.5234}).wait(1).to({graphics:mask_graphics_12,x:23.283,y:10.5258}).wait(1).to({graphics:mask_graphics_13,x:25.6053,y:10.5282}).wait(1).to({graphics:mask_graphics_14,x:27.9275,y:10.5307}).wait(1).to({graphics:mask_graphics_15,x:30.2498,y:10.5331}).wait(1).to({graphics:mask_graphics_16,x:32.5721,y:10.5355}).wait(1).to({graphics:mask_graphics_17,x:34.8944,y:10.5379}).wait(1).to({graphics:mask_graphics_18,x:37.2166,y:10.5403}).wait(1).to({graphics:mask_graphics_19,x:39.5389,y:10.5427}).wait(1).to({graphics:mask_graphics_20,x:41.8612,y:10.5451}).wait(1).to({graphics:mask_graphics_21,x:44.1835,y:10.5476}).wait(1).to({graphics:mask_graphics_22,x:46.5057,y:10.55}).wait(1).to({graphics:mask_graphics_23,x:48.828,y:10.5524}).wait(1).to({graphics:mask_graphics_24,x:51.1503,y:10.5548}).wait(1).to({graphics:mask_graphics_25,x:53.4725,y:10.5572}).wait(1).to({graphics:mask_graphics_26,x:55.7948,y:10.5596}).wait(1).to({graphics:mask_graphics_27,x:58.1171,y:10.562}).wait(1).to({graphics:mask_graphics_28,x:60.4394,y:10.5644}).wait(1).to({graphics:mask_graphics_29,x:62.7616,y:10.5669}).wait(1).to({graphics:mask_graphics_30,x:65.0839,y:10.5693}).wait(1).to({graphics:mask_graphics_31,x:67.4062,y:10.5717}).wait(1).to({graphics:mask_graphics_32,x:69.7285,y:10.5741}).wait(1).to({graphics:mask_graphics_33,x:72.0507,y:10.5765}).wait(1).to({graphics:mask_graphics_34,x:74.373,y:10.5789}).wait(1).to({graphics:mask_graphics_35,x:76.6953,y:10.5813}).wait(1).to({graphics:mask_graphics_36,x:79.0175,y:10.5838}).wait(1).to({graphics:mask_graphics_37,x:81.3398,y:10.5862}).wait(1).to({graphics:mask_graphics_38,x:83.6621,y:10.5886}).wait(1).to({graphics:mask_graphics_39,x:85.9844,y:10.591}).wait(1).to({graphics:mask_graphics_40,x:88.3066,y:10.5934}).wait(1).to({graphics:mask_graphics_41,x:90.6289,y:10.5958}).wait(1).to({graphics:mask_graphics_42,x:92.9512,y:10.5982}).wait(1).to({graphics:mask_graphics_43,x:95.2735,y:10.6006}).wait(1).to({graphics:mask_graphics_44,x:97.5957,y:10.6031}).wait(1).to({graphics:mask_graphics_45,x:99.918,y:10.6055}).wait(1).to({graphics:mask_graphics_46,x:102.2403,y:10.6079}).wait(1).to({graphics:mask_graphics_47,x:104.5626,y:10.6103}).wait(1).to({graphics:mask_graphics_48,x:106.8848,y:10.6127}).wait(1).to({graphics:mask_graphics_49,x:109.2071,y:10.6151}).wait(1).to({graphics:mask_graphics_50,x:111.5294,y:10.6175}).wait(1).to({graphics:mask_graphics_51,x:113.8516,y:10.62}).wait(1).to({graphics:mask_graphics_52,x:116.1739,y:10.6224}).wait(1).to({graphics:mask_graphics_53,x:118.4962,y:10.6248}).wait(1).to({graphics:mask_graphics_54,x:120.8185,y:10.6272}).wait(1).to({graphics:mask_graphics_55,x:123.1407,y:10.6296}).wait(1).to({graphics:mask_graphics_56,x:125.463,y:10.632}).wait(1).to({graphics:mask_graphics_57,x:127.7853,y:10.6344}).wait(1).to({graphics:mask_graphics_58,x:130.1076,y:10.6369}).wait(1).to({graphics:mask_graphics_59,x:132.4298,y:10.6393}).wait(1).to({graphics:mask_graphics_60,x:134.7521,y:10.6417}).wait(1).to({graphics:mask_graphics_61,x:137.0744,y:10.6441}).wait(1).to({graphics:mask_graphics_62,x:139.3967,y:10.6465}).wait(1).to({graphics:mask_graphics_63,x:141.7189,y:10.6489}).wait(1).to({graphics:mask_graphics_64,x:144.0412,y:10.6513}).wait(1).to({graphics:mask_graphics_65,x:146.3635,y:10.6537}).wait(1).to({graphics:mask_graphics_66,x:148.6857,y:10.6562}).wait(1).to({graphics:mask_graphics_67,x:151.008,y:10.6586}).wait(1).to({graphics:mask_graphics_68,x:153.3303,y:10.661}).wait(1).to({graphics:mask_graphics_69,x:155.6526,y:10.6634}).wait(1).to({graphics:mask_graphics_70,x:157.9748,y:10.6658}).wait(1).to({graphics:mask_graphics_71,x:160.2971,y:10.6682}).wait(1).to({graphics:mask_graphics_72,x:162.6194,y:10.6706}).wait(1).to({graphics:mask_graphics_73,x:164.9417,y:10.6731}).wait(1).to({graphics:mask_graphics_74,x:167.2639,y:10.6755}).wait(1).to({graphics:mask_graphics_75,x:169.5862,y:10.6779}).wait(1).to({graphics:mask_graphics_76,x:171.9085,y:10.6803}).wait(1).to({graphics:mask_graphics_77,x:174.2307,y:10.6827}).wait(1).to({graphics:mask_graphics_78,x:176.553,y:10.6851}).wait(1).to({graphics:mask_graphics_79,x:178.8753,y:10.6875}).wait(1).to({graphics:mask_graphics_80,x:181.1976,y:10.6899}).wait(1).to({graphics:mask_graphics_81,x:183.5198,y:10.6924}).wait(1).to({graphics:mask_graphics_82,x:185.8421,y:10.6948}).wait(1).to({graphics:mask_graphics_83,x:188.1644,y:10.6972}).wait(1).to({graphics:mask_graphics_84,x:190.4867,y:10.6996}).wait(1).to({graphics:mask_graphics_85,x:192.8089,y:10.702}).wait(1).to({graphics:mask_graphics_86,x:195.1312,y:10.7044}).wait(1).to({graphics:mask_graphics_87,x:197.4535,y:10.7068}).wait(1).to({graphics:mask_graphics_88,x:199.7757,y:10.7093}).wait(1).to({graphics:mask_graphics_89,x:202.098,y:10.7117}).wait(1).to({graphics:mask_graphics_90,x:204.4203,y:10.7141}).wait(1).to({graphics:mask_graphics_91,x:206.7426,y:10.7165}).wait(1).to({graphics:mask_graphics_92,x:209.0648,y:10.7189}).wait(1).to({graphics:mask_graphics_93,x:211.3871,y:10.7213}).wait(1).to({graphics:mask_graphics_94,x:213.7094,y:10.7237}).wait(1).to({graphics:mask_graphics_95,x:216.0317,y:10.7261}).wait(1).to({graphics:mask_graphics_96,x:218.3539,y:10.7286}).wait(1).to({graphics:mask_graphics_97,x:220.6762,y:10.731}).wait(1).to({graphics:mask_graphics_98,x:222.9985,y:10.7334}).wait(1).to({graphics:mask_graphics_99,x:224.5996,y:10.4471}).wait(1));

	// Layer_2
	this.instance = new lib.loading();
	this.instance.setTransform(-6,-3,0.45,0.45);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(100));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6,-1.1,459,23.400000000000002);


(lib.AUDIO_notify = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.textField = new cjs.Text("ZET JE GELUID AAN", "24px 'JetBrains Mono'", "#FFFFFF");
	this.textField.name = "textField";
	this.textField.textAlign = "right";
	this.textField.lineHeight = 34;
	this.textField.lineWidth = 261;
	this.textField.parent = this;
	this.textField.setTransform(88.05,-15.85);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	// icon
	this.icon = new lib.HeadphoneIcon();
	this.icon.name = "icon";
	this.icon.setTransform(128.5,-3.5);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// AUDIO_NOTE.png
	this.instance = new lib.AUDIO_NOTE();
	this.instance.setTransform(-201,-57.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.AUDIO_notify, new cjs.Rectangle(-201,-57.5,402,115), null);


(lib.PlaceholderButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disLabelTextField
	this.disabledLabelTextField = new cjs.Text("START", "36px 'JetBrains Mono'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 50;
	this.disabledLabelTextField.lineWidth = 134;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0,-23.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("START", "36px 'JetBrains Mono'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 50;
	this.downLabelTextField.lineWidth = 134;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0,-23.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("START", "36px 'JetBrains Mono'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 50;
	this.overLabelTextField.lineWidth = 134;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0,-23.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("START", "36px 'JetBrains Mono'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 50;
	this.upLabelTextField.lineWidth = 134;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0,-23.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.START_up2();
	this.instance.setTransform(-110,-58);

	this.instance_1 = new lib.START_down2();
	this.instance_1.setTransform(-110,-58);

	this.instance_2 = new lib.START_over2();
	this.instance_2.setTransform(-110,-58);

	this.instance_3 = new lib.back_disabled();
	this.instance_3.setTransform(1,0.5);
	this.instance_3.alpha = 0.5;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-110,-58,220,115.5);


(lib.SplashLoadScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.audioNote = new lib.AUDIO_notify();
	this.audioNote.name = "audioNote";
	this.audioNote.setTransform(712.3,-396.5);

	this.timeline.addTween(cjs.Tween.get(this.audioNote).wait(1));

	// startButton
	this.startButton = new lib.PlaceholderButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(0,399.6,1,1,0,0,0,-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.startButton).wait(1));

	// privacyTextField
	this.privacyTextField = new cjs.Text("[Door op 'START' te klikken ga je akkoord met het privacybeleid]", "22px 'JetBrains Mono'", "#CCCCCC");
	this.privacyTextField.name = "privacyTextField";
	this.privacyTextField.textAlign = "center";
	this.privacyTextField.lineHeight = 30;
	this.privacyTextField.lineWidth = 1131;
	this.privacyTextField.parent = this;
	this.privacyTextField.setTransform(0,471.55);
ranj.TextOffsetFixer.fix(this.privacyTextField);

	this.timeline.addTween(cjs.Tween.get(this.privacyTextField).wait(1));

	// loadingTextField
	this.loadingTextField = new cjs.Text("Loading", "22px 'JetBrains Mono'", "#FFFFFF");
	this.loadingTextField.name = "loadingTextField";
	this.loadingTextField.textAlign = "center";
	this.loadingTextField.lineHeight = 30;
	this.loadingTextField.lineWidth = 311;
	this.loadingTextField.parent = this;
	this.loadingTextField.setTransform(0,471.55);
ranj.TextOffsetFixer.fix(this.loadingTextField);

	this.timeline.addTween(cjs.Tween.get(this.loadingTextField).wait(1));

	// subTitle
	this.subTitleInput = new cjs.Text("The link to high-performance teams", "50px 'Adam Bold'", "#FFFFFF");
	this.subTitleInput.name = "subTitleInput";
	this.subTitleInput.lineHeight = 49;
	this.subTitleInput.lineWidth = 802;
	this.subTitleInput.parent = this;
	this.subTitleInput.setTransform(-401.15,-203.6);
ranj.TextOffsetFixer.fix(this.subTitleInput);

	this.timeline.addTween(cjs.Tween.get(this.subTitleInput).wait(1));

	// loadingBar
	this.loadingBar = new lib.LoadingBar();
	this.loadingBar.name = "loadingBar";
	this.loadingBar.setTransform(-244,451.15);

	this.timeline.addTween(cjs.Tween.get(this.loadingBar).wait(1));

	// bg_image
	this.bgImageContainer = new lib.bg_ImageContainer();
	this.bgImageContainer.name = "bgImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.bgImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SplashLoadScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1081), null);


// stage content:
(lib.SplashAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(802,542,1280,540);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#000000",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/SplashAssets/AUDIO_NOTE.png", id:"SplashAssets_AUDIO_NOTE", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/headphone.png", id:"SplashAssets_headphone", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/loading.png", id:"SplashAssets_loading", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/SplashScreen_BG_v02.jpg", id:"SplashAssets_SplashScreen_BG_v02", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/START_down2.png", id:"SplashAssets_START_down2", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/START_over2.png", id:"SplashAssets_START_over2", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/START_up2.png", id:"SplashAssets_START_up2", bundle:"SplashAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.SplashAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.SplashAssets;